import { useTheme } from '../theme/ThemeProvider';
import type { ThemeTokens } from '../theme/tokens';
import { useIconRenderer } from './IconProvider';
import type { IconName } from './iconNames';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type IconTone =
  | 'default'
  | 'muted'
  | 'primary'
  | 'inverse'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

export type IconProps = {
  name: IconName;
  size?: IconSize | number;
  tone?: IconTone;
  color?: string;
};

export function iconToneColor(theme: ThemeTokens, tone: IconTone): string {
  switch (tone) {
    case 'muted':
      return theme.colors.textMuted;
    case 'primary':
      return theme.colors.primary;
    case 'inverse':
      return theme.colors.textInverse;
    case 'success':
      return theme.colors.success;
    case 'warning':
      return theme.colors.onWarningSubtle;
    case 'danger':
      return theme.colors.danger;
    case 'info':
      return theme.colors.onInfoSubtle;
    case 'default':
    default:
      return theme.colors.text;
  }
}

export function Icon({ name, size = 'md', tone = 'default', color }: IconProps) {
  const theme = useTheme();
  const Renderer = useIconRenderer();

  if (Renderer === null) {
    return null;
  }

  return (
    <Renderer
      name={name}
      size={typeof size === 'number' ? size : theme.iconSize[size]}
      color={color ?? iconToneColor(theme, tone)}
    />
  );
}
